// Generated by CoffeeScript 2.7.0
var CascadedSelect;

import Base from './base.js';

export default CascadedSelect = (function() {
  class CascadedSelect extends Base {};

  CascadedSelect.setAttributes(['cascaded_select_id']);

  return CascadedSelect;

}).call(this);
